<article class="no-badge">
  <div class="row text-center">
    <div class="mx-auto text-left">
      <div>
        <h1>{{title}}</h1>
        
        <p class="main" [innerHTML]="message"></p>
        
        <div class="actions">
          <a class="btn btn-secondary" (click)="close()" href="javascript:;">OK</a>
        </div>
        
      </div>
    </div>
  </div>
</article>